import axios from "./axios";

export default {
    // Nuevo: Agregar imágenes a un reporte (todo en una transacción)
    addImagesToReport(reportId, formData) {
        const options = {
            method: 'POST',
            url: `clinicalreports/${reportId}/images`,
            data: formData
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.message)
                })
        })
    },

    getImagesByReportId(reportId) {
        const options = {
            method: 'GET',
            url: `clinicalreports/${reportId}/images`,
            headers: { 'content-type': 'application/json' }
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.message)
                })
        })
    },

    deleteRelationship(data) {
        const options = {
            method: 'DELETE',
            url: `clinicalreports/images/relationship`,
            headers: { 'content-type': 'application/json' },
            data: data
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.message)
                })
        })
    }
}
